import { observer } from 'mobx-react-lite';
import { Grid, Header, Segment, SemanticSIZES } from 'semantic-ui-react';
import { PermitFormValues } from '../../../../app/models/permit';
import StepMenu from '../../steps/StepMenu';
import PermitFormStep3WorkdestAddForm from './PermitFormStep3WorkdestAddForm';

interface Props {
    values: PermitFormValues,
    prev: () => void,
    next: () => void,
    goTo: (step: number) => void,
    buttonSize: SemanticSIZES
}

export default observer(function PermitFormStep3({ 
    values,
    next,
    prev,
    goTo,
    buttonSize
 }: Props) {
    return (
        <>
            <StepMenu currentTab={values.step} position='top' permitTypeId={values.permitTypeId}/>

            <Segment attached clearing>
                <Header 
                    as='h2' 
                    icon='user' 
                    content='Work Destination of Primary Driver'
                />

                <Grid centered>
                    <Grid.Column width={16}>
                        <PermitFormStep3WorkdestAddForm propValues={values} goTo={goTo} prev={prev} 
                            next={next} buttonSize={buttonSize} />
                    </Grid.Column>
                </Grid>
            </Segment>
        </>
    )
})